import { Components, outlinedInputClasses, Theme } from '@mui/material';

export const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    root: ({ theme }) => {
      if (!theme.featureFlags.panwRebrandStubYear) return {};

      const { borderColor, focusBorderColor, hoverBorderColor } = theme.palette.input;
      return {
        ...(focusBorderColor !== undefined && {
          [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: `${focusBorderColor} !important`,
          },
        }),
        ...(hoverBorderColor !== undefined && {
          [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: `${hoverBorderColor} !important`,
          },
        }),
        [`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: `${borderColor} !important`,
        },
        [`&.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: 'transparent !important',
          borderBottomWidth: '2px',
          borderBottomColor: `${theme.palette.input.errorColor} !important`,
          borderBottomLeftRadius: theme.shape.borderRadius,
          borderBottomRightRadius: theme.shape.borderRadius,
        },
      };
    },
    notchedOutline: ({ theme }) => ({
      borderColor: theme.palette.input.borderColor,
    }),
  },
};
